import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * The whole company brings the information with
 * the information of the permissions of
 * the e-mail addresses of the stolen.
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const users = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report || '',
  };

  fetch(endpoint('/report-user-list'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default users;
